import type { ViewStyle } from 'react-native';

import { Box } from '../../../../../../mads';
import { StickyShadow } from '../StickyShadow/StickyShadow';

import React, { type PropsWithChildren, type ReactElement } from 'react';

type WithOptionalEnticerTextProps = PropsWithChildren & {
    optionalContent?: ReactElement;
    useStickyShadow?: boolean;
};

const enticerStyle: ViewStyle = {
    backgroundColor: 'white',
};

const contentContainerStyle: ViewStyle = {
    justifyContent: 'center',
    alignItems: 'center',
};

const contentStyle: ViewStyle = {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 2,
};
/**
 * A wrapper component that conditionally renders an enticer UI around its children.
 *
 * @example
 * <WithOptionalCtaEnticerBanner optionalContent={<EnticerText />}>
 *   <ApplyButton />
 * </WithOptionalCtaEnticerBanner>
 *
 * @returns A StickyShadow wrapped component that either:
 * - Renders children directly if no optionalContent is provided
 * - Wraps children with an enticer UI container if optionalContent exists
 */
export const WithOptionalCTAEnticerBannerUI: React.FC<WithOptionalEnticerTextProps> = ({
    optionalContent,
    children,
    useStickyShadow = false,
}) => {
    return (
        <StickyShadow enabled={useStickyShadow}>
            {optionalContent ? (
                <Box sx={enticerStyle} id="with-optional-enticer-test">
                    <Box sx={contentContainerStyle}>
                        <Box sx={contentStyle}>{optionalContent}</Box>
                    </Box>
                    {children}
                </Box>
            ) : (
                children
            )}
        </StickyShadow>
    );
};
